import Avatar from 'components/Avatar';
import Button from 'components/Button';
import Paragraph from 'components/Typography/Paragraph';
import { t } from 'i18next';
import { TooltipRenderProps } from 'react-joyride';
import {
  AnimetedSpeechBox,
  Content,
  TitleBox,
  Wrapper,
} from './OnBoardingTooltip.styles';

const OnBoardingTooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
}: TooltipRenderProps) => {
  return (
    <Wrapper {...tooltipProps}>
      <Avatar className="mt-6" avatarName="" bgColor="#FDC800" />
      <AnimetedSpeechBox
        width="94%"
        cornPosition="left"
        hasLightBorder={false}
        translateCorn="-90%"
      >
        <Content>
          <TitleBox>
            {step.content && <Paragraph>{step.content}</Paragraph>}
          </TitleBox>
          {continuous && (
            <Button
              color="#161F21"
              bgColor="#FED132"
              shadowColor="#161F21"
              width="90%"
              {...primaryProps}
            >
              <span>{t('understand')}</span>
            </Button>
          )}
          {!continuous && (
            <Button {...closeProps}>
              <span>{t('understand')}</span>
            </Button>
          )}
        </Content>
      </AnimetedSpeechBox>
    </Wrapper>
  );
};

export default OnBoardingTooltip;
